"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var harris_icon_font_1 = __importDefault(require("@rotaryintl/harris-icon-font"));
var hook_use_local_storage_1 = __importDefault(require("@rotaryintl/hook-use-local-storage"));
require("./styles.css");
var classMap = {
    info: 'info',
    warning: 'warning',
    critical: 'critical',
};
var GlobalBannerNotification = function (_a) {
    var title = _a.title, text = _a.text, className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'info' : _b, _c = _a.isDismissible, isDismissible = _c === void 0 ? true : _c, storageId = _a.storageId;
    var classes = (0, classnames_1.default)(className, {
        'rotaryui-global-banner-notification': true,
    }, classMap[variant]);
    /* eslint-disable  @typescript-eslint/no-non-null-assertion */
    var _d = (0, react_1.useState)(false), isVisible = _d[0], setIsVisible = _d[1];
    var _e = (0, hook_use_local_storage_1.default)(), getLocalStorageData = _e.getLocalStorageData, setLocalStorageData = _e.setLocalStorageData;
    (0, react_1.useEffect)(function () {
        if (isDismissible) {
            if (typeof document !== 'undefined' && getLocalStorageData(storageId)) {
                setIsVisible(false);
            }
            else {
                setIsVisible(true);
            }
        }
    }, []);
    var handleClick = function () {
        if (isDismissible) {
            setLocalStorageData(storageId, storageId);
            setIsVisible(false);
        }
    };
    if (!isVisible && isDismissible) {
        return null;
    }
    if (isDismissible === true && !storageId) {
        // eslint-disable-next-line no-console
        console.warn('Warning: An ID field needs to be set for dismissible alerts.');
    }
    var icon = ((0, jsx_runtime_1.jsxs)("span", { children: [variant === 'info' ? ((0, jsx_runtime_1.jsx)(harris_icon_font_1.default, { className: classMap[variant], type: "fas-info-circle", size: "24" })) : null, variant === 'critical' ? ((0, jsx_runtime_1.jsx)(harris_icon_font_1.default, { className: classMap[variant], type: "fas-triangle-exclamation", size: "24" })) : null, variant === 'warning' ? ((0, jsx_runtime_1.jsx)(harris_icon_font_1.default, { className: classMap[variant], type: "fas-circle-exclamation", size: "24" })) : null] }));
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes, role: "alert" }, { children: [(0, jsx_runtime_1.jsxs)("section", { children: [title ? ((0, jsx_runtime_1.jsx)("header", { children: (0, jsx_runtime_1.jsxs)("h4", { children: [icon, (0, jsx_runtime_1.jsx)("span", { children: title })] }) })) : null, (0, jsx_runtime_1.jsxs)("p", { children: [title ? null : icon, " ", (0, jsx_runtime_1.jsx)("span", { children: text })] })] }), storageId !== '' && storageId !== undefined && isDismissible && ((0, jsx_runtime_1.jsx)("button", __assign({ type: "button", "aria-label": "close", className: "dismiss", onClick: handleClick }, { children: (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, { type: "fas-xmark", size: "24" }) })))] })));
};
exports.default = GlobalBannerNotification;
//# sourceMappingURL=global-banner-notification.component.js.map